import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NotificationSeveritySummaryDTO } from '@app/core/models/notification-severity-summary-dto';
import { environment } from '@environment/environment';


@Injectable({
  providedIn: 'root'
})
export class NotificationSeveritySummaryService extends BehaviorSubject<NotificationSeveritySummaryDTO[]> {
  constructor(private readonly httpClient: HttpClient) {
    super([]);
  }

  public async query(): Promise<void> {
    var res = this.httpClient.get<NotificationSeveritySummaryDTO[]>(`${environment.apiUrl}master/notification/summary`).toPromise();
    this.next(await res);
  }
}
